import React from 'react';
import {Form, Dropdown} from 'semantic-ui-react';
import NumberFormat from 'react-number-format';
import DatePicker from 'react-datepicker';
import {VEHICLE_STATE} from '../../constants';


const FormVehicleWarranty = ({
  vehicleState,
  handleSelectStatus,
  handleSelect,
  handleMilesInput,
  validateStatus,
  handleChangeDate,
}) => {
  const {km, endSaleDate, vehicleStatus} = vehicleState;

  return (
    <Form>
      <div className="tcc-wrapper">
        <Form.Group widths="three">
          <Form.Field
            disabled={validateStatus}
            control={Dropdown}
            options={VEHICLE_STATE}
            onChange={(e, {value}) => handleSelectStatus(e, 'vehicleStatus', value)}
            value={vehicleStatus}
            fluid
            search
            selection
            type="text"
            label="Estado del vehículo"
            placeholder="Seleccione el estado"
          />
          <Form.Input fluid label="Fecha de venta del concesionario al cliente">
            <DatePicker
              disabled={validateStatus}
              placeholderText="Fecha venta cliente final"
              className="tcc-datepicker"
              showYearDropdown
              selected={endSaleDate}
              dateFormat="yyyy/MM/dd"
              onChange={handleChangeDate}
            />
          </Form.Input>
          <Form.Field>
            <label>Kilometraje (km)</label>
            <NumberFormat
              disabled={validateStatus}
              placeholder="Kilometraje"
              value={km}
              thousandSeparator={true}
              onValueChange={(event) => handleMilesInput(event, 'km')}
            />
          </Form.Field>
        </Form.Group >
      </div>
    </Form>
  );
};

export default FormVehicleWarranty;
